import React, { useState } from 'react';
import commonStyles from "components/commonStyle/commonStyle.module.css";

import AsyncSelect from 'react-select/async';
import { searchKids } from 'services/profileManegement/search-kid';
import { FaSearch } from 'react-icons/fa';
import { components } from 'react-select';
import Popup from 'components/Popup/popup';
import { getKidContact } from 'services/profileManegement/get-kid-contact';

interface Option {
  value: string;
  label: string;
}

export default function SearchKidsSelect() {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedKid, setSelectedKid] = useState<Option | null>(null);
  const [kidDetails, setKidDetails] = useState<{ name: string; age: number; emergencyContacts: { name: string; phone: string }[] } | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const loadOptions = async (inputValue: string): Promise<Option[]> => {
    if (!inputValue) {
      return [];
    }

    setIsLoading(true);
    try {
      const data = await searchKids(inputValue);
      if (Array.isArray(data)) {
        return data.map((kid: { value: string; label: string }) => ({
          value: kid.value,
          label: kid.label,
        }));
      } else {
        return [];
      }
    } catch (error) {
      console.error('Fehler beim Abrufen der Kinder-Daten', error);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const handleKidSelect = async (selectedOption: Option | null) => {
    setSelectedKid(selectedOption);
    if (selectedOption) {
      try {
        const kidData = await getKidContact(Number(selectedOption.value));
        setKidDetails({
          name: kidData.kid_full_name,
          age: kidData.kid_age,
          emergencyContacts: kidData.emergency_contacts,
        });
        setIsPopupOpen(true);
      } catch (error) {
        console.error("Fehler beim Laden der Kontaktdaten des Kindes:", error);
      }
    } else {
      setKidDetails(null);
    }
  };

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: '#6c757d',
      boxShadow: 'none',
      fontSize: window.innerWidth <= 450 ? '12px' : '16px',

      '&:hover': {
        borderColor: '#495057',
      },
      minHeight: '30px',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      fontSize: window.innerWidth <= 450 ? '12px' : '16px',
      color: '#6c757d',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      padding: '8px',
      color: '#495057',
    }),
  };

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaSearch />
      </components.DropdownIndicator>
    );
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setKidDetails(null);
    setSelectedKid(null)
  };

  return (
    <div>
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions
        isLoading={isLoading}
        value={selectedKid}
        placeholder=" Notfallkontakt für ..."
        isClearable
        noOptionsMessage={() => "Keine Ergebnisse"}
        styles={customStyles}
        components={{ DropdownIndicator }}
        onChange={handleKidSelect}
      />

      {isPopupOpen && kidDetails && (
        <Popup
          title={`Notfallkontakte `}
          submitLabel="Close"
          closeLabel="Close"
          isWithButton={false}
          isOpen={isPopupOpen}
          onClose={closePopup}          >
          <div>
            <div className={commonStyles.formGroupRow}>
              <div className={commonStyles.formGroup}>
                <label>Name Kind</label>
                <p> {kidDetails.name}</p>
              </div>
              <div className={commonStyles.formGroup}>
                <label>Alter</label>
                <p> {kidDetails.age}</p>
              </div>
            </div>
            <div className={commonStyles.formGroupRow}>
              <div className={commonStyles.formGroup}>
                <label>Name </label>
              </div>
              <div className={commonStyles.formGroup}>
                <label>Nummer</label>
              </div>
            </div>
            
              {kidDetails.emergencyContacts.map((contact, index) => (
                <div className={commonStyles.formGroupRow}>
                <div className={commonStyles.formGroup}>
                  <p> {contact.name}</p>
                </div>
                <div className={commonStyles.formGroup}>
                  <p> {contact.phone}</p>
                </div>
              </div>
               
              ))}
            
          </div>
        </Popup>
      )}
    </div>
  );
}
